import React, { createContext, useContext } from 'react';
import { useWindowWidth } from './WindowWidthContext';

interface MobileContextType {
    isMobile: boolean;
    mobileWidth: number;
}

const MobileContext = createContext<MobileContextType | undefined>(undefined);

const MOBILE_WIDTH = 768;

export function MobileProvider({ children }: { children: React.ReactNode }) {
    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < MOBILE_WIDTH;

    return (
        <MobileContext.Provider value={{ isMobile, mobileWidth: MOBILE_WIDTH }}>
            {children}
        </MobileContext.Provider>
    );
}

export function useMobile() {
    const context = useContext(MobileContext);
    if (context === undefined) {
        throw new Error('useMobile must be used within a MobileProvider');
    }
    return context;
}

